import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { SafeHtml } from '@shared/ui';
export const OptionsList = ({ options, className }) => {
    const { OptionsList: theme } = useTheme('InsurancePage');
    return (React.createElement("ul", { className: cn(theme.list, className) }, options.map(option => (React.createElement(SafeHtml, { key: option, tag: "li", html: option })))));
};
